import { Pipe, PipeTransform } from '@angular/core';
import { stripHtml } from '../_helpers/html.helper';

@Pipe({ name: 'stripHtml' })
export class StripHtmlPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return stripHtml(value);
  }
}
